import { firebaseEnvironment } from "../firebase";
import { SPINNER_STRINGS } from "../data/spinnerStrings";

const OTP_API = {
  send: "https://sendotp-qy6gtydyyq-uc.a.run.app",
  verify: "https://verifyotp-qy6gtydyyq-uc.a.run.app",
};

export const normalizePhoneNumber = (phone = "") => phone.replace(/\D/g, "").slice(-10);

export const sendSpinnerOtp = async (phone) => {
  const normalizedPhone = normalizePhoneNumber(phone);
  const otpStrings = SPINNER_STRINGS.otp;

  if (normalizedPhone.length < 10) {
    return { ok: false, message: otpStrings.invalidNumber };
  }

  if (firebaseEnvironment === "dev") {
    return {
      ok: true,
      token: "mock-dev-token",
      message: otpStrings.mockHelp,
    };
  }

  try {
    const response = await fetch(`${OTP_API.send}/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone: normalizedPhone }),
    });

    const data = await response.json();

    if (!response.ok) {
      const apiError = data?.error || data?.errorMsg || "Failed to send OTP.";
      return {
        ok: false,
        message:
          apiError === "invalid-number"
            ? otpStrings.invalidNumber
            : otpStrings.sendApiError,
      };
    }

    return {
      ok: true,
      token: data?.token || "",
      message: otpStrings.otpSentSuccess,
    };
  } catch (error) {
    console.error(error);
    return {
      ok: false,
      message: otpStrings.sendApiUnavailable,
    };
  }
};

export const verifySpinnerOtp = async ({ token, otp }) => {
  const otpStrings = SPINNER_STRINGS.otp;
  if (!token) {
    return { ok: false, message: otpStrings.sendFirst };
  }

  if (firebaseEnvironment === "dev") {
    return otp?.trim() === "123456"
      ? { ok: true, message: otpStrings.verifySuccess, firebaseToken: "mock-dev-custom-token" }
      : { ok: false, message: otpStrings.verifyMockError };
  }

  try {
    const response = await fetch(`${OTP_API.verify}/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, otp }),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        ok: false,
        message: data?.error || data?.errorMsg || otpStrings.verifyApiError,
      };
    }

    return {
      ok: true,
      message: otpStrings.verifySuccess,
      firebaseToken: data?.customToken || data?.firebaseToken || data?.token || "",
    };
  } catch (error) {
    console.error(error);
    return { ok: false, message: otpStrings.verifyApiUnavailable };
  }
};